import { AccountBalanceWallet } from '@assets/svgs/AccountBalanceWallet'
import { CurrencyDollarSimple } from '@assets/svgs/CurrencyDollarSimple'
import { InfoIcon } from '@assets/svgs/InfoIcon'
import { TrendingDown } from '@assets/svgs/TrendingDown'
import { currencyMask } from '@utils/masks/currencyMask'

import { TooltipExplanation } from '@components/shared/TooltipExplanation/inde'
import { PreviewCard } from '../PreviewCard'
import { TrendingUp } from '@assets/svgs/TrendingUp'
import type { ConsolidatedPreviewProps } from './types'

export const consolidatedPreview = ({ data }: ConsolidatedPreviewProps) => {
  if (!data) return []

  return [
    <PreviewCard
      label="Budget"
      previewType="budget"
      value={`Fat. ${currencyMask(data.budget.billingBudget?.toFixed(2))}`}
      gpValue={currencyMask(data.budget.grossProfit?.toFixed(2))}
      gmPercentage={data.budget.grossMargin ? `${data.budget.grossMargin?.toFixed(2)}%`.replace('.', ',') : ''}
      icon={<AccountBalanceWallet />}
      infoIcon={
        <TooltipExplanation
          data={[
            { label: 'GP é o Gross Profit e GM é o Gross Margin' },
            { label: 'Fat. = ', text: 'Budget de Faturamento' },
            { label: 'GP = ', text: 'Soma dos budgets de todas as contas' },
            { label: 'GM = ', text: 'GP / Fat. * 100' }
          ]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />,
    <PreviewCard
      label="Prévia Atual"
      previewType="preview"
      value={`Fat. ${currencyMask(data.currentPreview.billingBudget?.toFixed(2))}`}
      gpValue={currencyMask(data.currentPreview.grossProfit?.toFixed(2))}
      gmPercentage={data.currentPreview.grossMargin ? `${data.currentPreview.grossMargin?.toFixed(2)}%`.replace('.', ',') : ''}
      icon={<CurrencyDollarSimple />}
      infoIcon={
        <TooltipExplanation
          data={[
            { label: 'GP é o Gross Profit e GM é o Gross Margin' },
            { label: 'Fat. = ', text: 'Prévia Atual de Faturamento' },
            { label: 'GP = ', text: 'Soma das prévias de todas as contas' },
            { label: 'GM = ', text: 'GP / Fat. * 100' }
          ]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />,
    <PreviewCard
      label="Desvio"
      previewType="detour"
      value={`Fat. ${currencyMask(data.deviation.billingBudget?.toFixed(2))}`}
      icon={Number(data.deviation.billingBudget) <= 0 ? <TrendingDown /> : <TrendingUp />}
      gpValue={currencyMask(data.deviation.grossProfit?.toFixed(2))}
      gmPercentage={data.deviation.grossMargin ? `${data.deviation.grossMargin?.toFixed(2)}%`.replace('.', ',') : ''}
      isNegative={Number(data.deviation.billingBudget) <= 0}
      infoIcon={
        <TooltipExplanation
          data={[
            { label: 'GP é o Gross Profit e GM é o Gross Margin' },
            { label: 'Fat. = ', text: 'Prévia Atual - Budget' },
            { label: 'GP = ', text: 'GP Prévia - GP Budget' },
            { label: 'GM = ', text: 'GM Prévia - GM Budget' }
          ]}
        >
          <InfoIcon />
        </TooltipExplanation>
      }
    />
  ]
}
